/**
 * 腾讯对象存储文件上传
 * Created by HeMengJiao on 2020/01/13.
 */
import axios from 'axios'
import AppConfig from '../appConfig'
import store from '../store/store'
import SparkMD5 from 'spark-md5'
import COS from 'cos-js-sdk-v5'

let objectStore = AppConfig.objectStore
/**
 * @param file
 * @param backtopage 回调方法，最多接收两个参数，无错误情况默认只传第一个参数，有报错时将报错放在第二个参数，第一个传空
 * */
export default function (file, backtopage) {
  let key = ''
  let accessPath = objectStore.ACCESSPATH + (store.state.user ? store.state.user.userId + '/' : '')
  let domain = objectStore.UPLOAD_DOMAIN

  // Vue.prototype.uploadFile = uploadFile
  // console.log('hhhhhhhhhhhhhhhhhhhhhhhhh')
  let cos = new COS({
    getAuthorization: function (params, callback) { // 获取签名 必填参数
      axios({
        method: 'post',
        baseURL: AppConfig.API.UPLOAD_URL,
        url: 'get/tmp/secret',
        data: params,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json; charset=UTF-8',
          'token': store.state.token ? store.state.token : ''
        }
      })
        .then((res) => {
          // console.log(res);
          if (Number(res.data.code) === 10000) {
            // console.log("异步获取临时秘钥成功");
            let data = res.data.data
            callback({
              TmpSecretId: data.tmpSecretId,
              TmpSecretKey: data.tmpSecretKey,
              // XCosSecurityToken: data.XCosSecurityToken,
              XCosSecurityToken: data.sessionToken,
              // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
              StartTime: data.startTime, // 单位是秒
              ExpiredTime: data.expiredTime // SDK 在 ExpiredTime 时间前，不会再次调用 getAuthorization
            })
          } else {
            console.log('异步获取临时秘钥失败')

            backtopage(res.data)
            // return res;
          }
        })
        .catch((err) => {
          console.log('无法执行异步获取临时秘钥')

          backtopage({
            code: -1,
            data: err,
            msg: '无法连接服务器，请检查网络~'
          })
          // return err;
        })
    }
  })
  // console.log(cos)
  uploadFile(file, backtopage)

  // 将上传文件的方法挂载到vue的原型链上面
  // Vue.prototype.uploadFile = uploadFile

  // 返回值处理
  let requestCallback = function (err, data, requestData) {
    // console.log("进入返回值处理");
    // console.log(err || data);
    if (err && err.error) {
      console.log('返回预期报错')
      console.log(key)
      backtopage({
        code: err.statusCode ? err.statusCode : 1,
        data: err,
        msg: err.error.Message ? err.error.Message : '返回预期报错'
      })
      // wx.showModal({ title: '返回错误', content: '请求失败：' + err.error.Message + '；状态码：' + err.statusCode, showCancel: false });
    } else if (err) {
      console.log('返回未知报错')
      console.log(key)
      backtopage({
        code: err.statusCode ? err.statusCode : 1,
        data: err,
        msg: err.error.Message ? err.error.Message : '返回未知报错'
      })
      // wx.showModal({ title: '请求出错', content: '请求出错：' + err + '；状态码：' + err.statusCode, showCancel: false });
    } else {
      // console.log("执行成功，进行回调");
      // backtopage(domain + key);
      backtopage(requestData)
      //  wx.showToast({ title: '上传成功', icon: 'success', duration: 3000 });
    }
  }

  // 上传文件
  function uploadFile (file, backtopage) {
    // console.log('nnnnnnnnnnnnnnnnnnn')
    // console.log(file)
    let requestData = {}
    // 得到md5码
    getFileMD5(file, md5 => {
      // 存储文件的md5码
      file.md5 = md5
      // console.log("得到md5码");
      // console.log(file.md5)
      let subfix = file.name.substr(file.name.lastIndexOf('.'))
      key = accessPath + file.md5 + subfix
      // console.log(accessPath)
      // console.log(key)

      // 初始化文件信息
      requestData.fileName = file.name
      requestData.fileSize = file.size
      requestData.fileUrl = domain + key

      cos.putObject({
        Bucket: objectStore.BUCKET, /* 必须 */
        Region: objectStore.REGION, /* 必须 */
        StorageClass: 'STANDARD',
        Key: key,
        Body: file,
        Domain: domain,
        onProgress: function (info) {
          // console.log("执行onProgress");
          // console.log(JSON.stringify(info));
        }
      }, function (err, data) {
        requestCallback(err, data, requestData)
      })

      /* cos.headObject({
        Bucket: objectStore.BUCKET, /!* 必须 *!/
        Region: objectStore.REGION, /!* 必须 *!/
        Key: key,                     /!* 必须 *!/
      }, function (err, data) {
        if (err != null) {
          console.log('wrong')
          console.log(err)

        } else if (data != null) {
          console.log("执行backtopage");
          backtopage(domain + key)
        }
      }); */
    })
  }

  // 获得文件md5
  function getFileMD5 (file, callback) {
    // 声明必要的变量
    let fileReader = new FileReader(),

      // 文件每块分割2M，计算分割详情
      chunkSize = 2097152,
      chunks = Math.ceil(file.size / chunkSize),
      currentChunk = 0,

      // 创建md5对象（基于SparkMD5）
      spark = new SparkMD5()

    // 每块文件读取完毕之后的处理
    fileReader.onload = function (e) {
      // 每块交由sparkMD5进行计算
      spark.appendBinary(e.target.result)
      currentChunk++

      // 如果文件处理完成计算MD5，如果还有分片继续处理
      if (currentChunk < chunks) {
        loadNext()
      } else {
        callback(spark.end())
      }
    }

    // 处理单片文件的上传
    function loadNext () {
      let start = currentChunk * chunkSize,
        end = start + chunkSize >= file.size ? file.size : start + chunkSize

      fileReader.readAsBinaryString(file.slice(start, end))
    }

    loadNext()
  }
}



// WEBPACK FOOTER //
// ./src/factory-api/uploadFile.js